// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Xc9G","left":"_3daAB","center":"_358IN","right":"Kzi9g"};